var _defs, _g, _g2, _g3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "ac2c1ea375"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "669014c70c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bf2d67cfc1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 9.144531 L 11.082031 9.144531 L 11.082031 10.597656 L 0.484375 10.597656 Z M 0.484375 9.144531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2513d43230"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.042969 9.941406 C 11.082031 9.902344 11.082031 9.839844 11.042969 9.800781 L 10.421875 9.179688 C 10.382812 9.140625 10.320312 9.140625 10.28125 9.179688 C 10.246094 9.21875 10.246094 9.277344 10.28125 9.316406 L 10.835938 9.871094 L 10.28125 10.425781 C 10.246094 10.464844 10.246094 10.523438 10.28125 10.5625 C 10.320312 10.601562 10.382812 10.601562 10.421875 10.5625 Z M -0.53125 9.96875 L 10.976562 9.96875 L 10.976562 9.773438 L -0.53125 9.773438 Z M -0.53125 9.96875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 11,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAADCAYAAABF//VLAAAABmJLR0QA/wD/AP+gvaeTAAAAHUlEQVQImWNkYGBQYmBgEINicSQ2BmZiIAGQpBgAcaUBBcRFb8QAAAAASUVORK5CYII=",
    id: "5b2fb55ba3",
    height: 3,
    preserveAspectRatio: "xMidYMid meet"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "9663dd3d5b"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ac2c1ea375)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 11,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAADCAYAAABF//VLAAAABmJLR0QA/wD/AP+gvaeTAAAAHUlEQVQImWNkYGBQYmBgEINicSQ2BmZiIAGQpBgAcaUBBcRFb8QAAAAASUVORK5CYII=",
    height: 3,
    preserveAspectRatio: "xMidYMid meet"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "53cb1c9a2a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 11,
    y: 0,
    height: 3
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "55e17c3884",
    patternUnits: "userSpaceOnUse",
    width: 11,
    patternTransform: "matrix(0.967742, 0, 0, -0.967742, 0.48387, 11.535484)",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 11 3",
    height: 3,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#53cb1c9a2a)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#9663dd3d5b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7.319999,
    width: 44.639999,
    fill: "#ffffff",
    height: 44.64,
    y: -25.9,
    fillOpacity: 1
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "59e8334f21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 2.617188 L 24.5625 2.617188 L 24.5625 25.84375 L 5 25.84375 Z M 5 2.617188 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#669014c70c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bf2d67cfc1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2513d43230)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#55e17c3884)",
    d: "M 0.484375 9.144531 L 11.082031 9.144531 L 11.082031 10.597656 L 0.484375 10.597656 Z M 0.484375 9.144531 ",
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#59e8334f21)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a7adc3",
    d: "M 5.566406 17.015625 L 14.347656 25.796875 C 14.660156 26.109375 15.152344 26.109375 15.464844 25.796875 L 24.246094 17.015625 C 24.5625 16.699219 24.5625 16.210938 24.246094 15.894531 C 23.933594 15.582031 23.441406 15.582031 23.128906 15.894531 L 15.683594 23.339844 L 15.683594 -15.929688 C 15.683594 -16.359375 15.328125 -16.714844 14.894531 -16.714844 C 14.464844 -16.714844 14.109375 -16.359375 14.109375 -15.929688 L 14.109375 23.339844 L 6.683594 15.894531 C 6.527344 15.738281 6.332031 15.660156 6.136719 15.660156 C 5.9375 15.660156 5.742188 15.738281 5.585938 15.894531 C 5.269531 16.210938 5.269531 16.699219 5.566406 17.015625 Z M 5.566406 17.015625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.1b1d0dad8656c62e282b346e0be468ad.svg";
export { ForwardRef as ReactComponent };